import React, { Component, ReactNode } from 'react'

import { AlertLayout } from './../index'

interface IAlertComponentProps {
    type?: 'info' | 'error' | 'success' | 'warning' | ''
    title?: string
    description?: string | ReactNode
    icon?: string
    sizeIcon?: string
    textAlign?: string
    textButton? :string
    showButton? : boolean
    onClick?: ()=>void
    styles?: any
    className?: string
}

interface IAlertComponentState {}

class AlertComponent extends Component<IAlertComponentProps, IAlertComponentState> {

  constructor(props: IAlertComponentProps){
    super(props)
  }

  render() {
    return (
      <AlertLayout
        type={this.props.type}
        title={this.props.title}
        description={this.props.description}
        icon={this.props.icon}
        textButton={this.props.textButton}
        onClick={this.props.onClick}
        showButton={this.props.showButton}
        sizeIcon={this.props.sizeIcon}
        textAlign={this.props.textAlign}
        styles={this.props.styles}
        className={this.props.className}
      />
    )
  }
}

export default AlertComponent
